export default "__VITE_ASSET__DFWhIh9Z__"